import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import useQuery from "../../hooks/useQuery";
import { hikerGenderState } from "../../atom/atom";
import { useRecoilState } from "recoil";
import { withOrientationChange } from "react-device-detect";
import { useTranslation } from "react-i18next";

import {
    Wrapper,
    StyledLogo,
    LottieCharWrapper,
    StyledLottie,
    StyledLottieBg,
    NextButton,
} from "./styles/CharacterReveal-styled.js";

import Grid from "@material-ui/core/Grid";

import shareJoyLogo from "../../assets/OnBoarding_Texture_Logo.png";
import shareJoyLogoBlack from "../../assets/logo/Black.png";
import shareJoyLogoWhite from "../../assets/logo/White.png";
import LoadingPage from "../LoadingPage";
import LandscapeErrorPage from "../ErrorPage/LandscapeErrorPage";

const lottieList = [
    "fishballs",
    "ferry",
    "hiker_twins",
    "lion",
    "milk_tea",
    "neon",
];

const CharacterReveal = (props) => {
    let history = useHistory();
    let query = useQuery();
    let { characterName } = useParams();
    const { isLandscape } = props;
    const { t, i18n } = useTranslation();
    const [isValidCharacter, setIsValidCharacter] = useState(false);
    const [lottieChar, setLottieChar] = useState("");
    const [lottieBg, setLottieBg] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [hikerGender, setHikerGender] = useRecoilState(hikerGenderState);

    const [isBlackLogo, setIsBlackLogo] = useState(true);

    useEffect(() => {
        if (characterName === "hiker_twins") {
            const rand = Math.floor(Math.random() * 10);
            if (rand % 2 === 0) {
                setHikerGender("hiker_girls");
            } else {
                setHikerGender("hiker_boys");
            }
        }
        if (
            characterName === "neon" ||
            characterName === "fishballs" ||
            characterName === "milk_tea"
        ) {
            setIsBlackLogo(false);
        }
    }, [characterName, setHikerGender]);

    useEffect(() => {
        setIsValidCharacter(lottieList.includes(characterName));
        if (isValidCharacter) {
            const lottieLoader = async () => {
                if (i18n.language === "zh") {
                    if (hikerGender !== "") {
                        if (hikerGender === "hiker_boys") {
                            const lottieData = await import(
                                `../../assets/lottie/lottie_zh/${hikerGender}.json`
                            );
                            setLottieChar(lottieData.default);
                        } else {
                            const lottieData = await import(
                                `../../assets/lottie/lottie_zh/${hikerGender}.json`
                            );
                            setLottieChar(lottieData.default);
                        }
                    } else {
                        const lottieData = await import(
                            `../../assets/lottie/lottie_zh/${characterName}.json`
                        );
                        setLottieChar(lottieData.default);
                    }
                } else {
                    if (hikerGender !== "") {
                        if (hikerGender === "hiker_boys") {
                            const lottieData = await import(
                                `../../assets/lottie/lottie_en/${hikerGender}.json`
                            );
                            setLottieChar(lottieData.default);
                        } else {
                            const lottieData = await import(
                                `../../assets/lottie/lottie_en/${hikerGender}.json`
                            );
                            setLottieChar(lottieData.default);
                        }
                    } else {
                        const lottieData = await import(
                            `../../assets/lottie/lottie_en/${characterName}.json`
                        );
                        setLottieChar(lottieData.default);
                    }
                }
                const lottieBgData = await import(
                    `../../assets/lottie/${characterName}_bg.json`
                );

                setLottieBg(lottieBgData.default);
                setIsLoading(false);
            };
            lottieLoader();
        }
    }, [characterName, isValidCharacter, i18n.language, hikerGender]);

    const handleNextButton = () => {
        const characterId = query.get("id");
        const url = characterName.replace(/\/\//g, "");
        history.push({ pathname: `${url}/mainpage`, search: characterId });
    };

    if (isValidCharacter) {
        if (isLandscape) {
            return <LandscapeErrorPage />;
        }
        if (isLoading) {
            return <LoadingPage />;
        }
        return (
            <Wrapper>
                <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                >
                    <StyledLogo
                        src={
                            isBlackLogo ? shareJoyLogoBlack : shareJoyLogoWhite
                        }
                        alt="share joy logo"
                    />
                    <LottieCharWrapper>
                        <StyledLottie
                            play
                            loop={false}
                            animationData={lottieChar}
                            rendererSettings={{
                                preserveAspectRatio: "xMidYMid slice",
                            }}
                        />
                    </LottieCharWrapper>
                    <StyledLottieBg
                        play
                        loop
                        animationData={lottieBg}
                        rendererSettings={{
                            preserveAspectRatio: "xMidYMid slice",
                        }}
                    />
                    <NextButton onClick={handleNextButton}>
                        {t("characterRevealPage.button.nextButton", "Next")}
                    </NextButton>
                </Grid>
            </Wrapper>
        );
    }
    return <div>NO CHARACTER</div>;
};

export default withOrientationChange(CharacterReveal);
